/* globals localStorage */
// grk code 20250707

// export const getRequestOptions = (token) => ({
//   headers: {
//     Authorization: `Bearer ${token}`,
//   },
// });

// XT 20260924:
// Include Console user email and nickname with authenticated API requests so
// backend diagnostics/audit logs can identify which Console user performed an action.
// These values come from the Auth0 profile stored in localStorage and are for
// identification/logging only. Backend authorization must continue to use the
// authenticated JWT/token (req.userid / Auth0 sub), not these client-supplied headers.
export const getRequestOptions = (token) => {
  let profile = {};

  try {
    profile = JSON.parse(localStorage.getItem('profile')) || {};
  } catch (error) {
    console.warn('ApiHelper - unable to read profile from localStorage');
  }

  return {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Console-User-Email': profile.email || '',
      'X-Console-User-Nickname': profile.nickname || '',
    },
  };
};